<app-header [isModulePage]="true" />
<main>
    <router-outlet />
</main>
<app-footer />
